<template>
<div id="addEdit">
  <el-dialog title="鉴定信息" :visible.sync="visible" width="800px">

    <div class="infoModel" v-if="detail!=null">


      <div class="info">
        <div class="tit">鉴定用户</div>
        <div class="text">
          <div class="userInfo">
            <img :src="detail.user.avatarUrl" alt="">
            <div class="main">
              <p class="name">{{ detail.user.nickName }}</p>
              <p class="text">ID:{{ detail.user.user_id }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="info" v-if="detail.category">
        <div class="tit">鉴定品类</div>
        <div class="text">{{ detail.category.name }}</div>
      </div>
      <div class="info" v-if="detail.asset_type_text">
        <div class="tit">资产类型</div>
        <div class="text">{{ detail.asset_type_text }}</div>
      </div>

      <!-- 奢侈品珠宝：asset_type = 1 -->
      <template v-if="detail.asset_type === 1">
        <div class="info">
          <div class="tit">品牌</div>
          <div class="text">{{ detail.brand_text || detail.brand }}</div>
        </div>
        <div class="info" v-if="detail.fineness_text">
          <div class="tit">成色</div>
          <div class="text">{{ detail.fineness_text }}</div>
        </div>
        <div class="info" v-if="attachmentDisplay(detail)">
          <div class="tit">附件</div>
          <div class="text">{{ attachmentDisplay(detail) }}</div>
        </div>
        <div class="info" v-if="detail.main_material_text">
          <div class="tit">主体材质</div>
          <div class="text">{{ detail.main_material_text }}</div>
        </div>
        <div class="info" v-if="detail.stone_material_text">
          <div class="tit">镶石材质</div>
          <div class="text">{{ detail.stone_material_text }}</div>
        </div>
        <div class="info" v-if="detail.size_desc">
          <div class="tit">尺寸/圈口</div>
          <div class="text">{{ detail.size_desc }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 手表：asset_type = 2 -->
      <template v-if="detail.asset_type === 2">
        <div class="info">
          <div class="tit">品牌</div>
          <div class="text">{{ detail.brand_text || detail.brand }}</div>
        </div>
        <div class="info" v-if="detail.gender_text">
          <div class="tit">性别/款式</div>
          <div class="text">{{ detail.gender_text }}</div>
        </div>
        <div class="info" v-if="detail.case_material_text">
          <div class="tit">表体材质</div>
          <div class="text">{{ detail.case_material_text }}</div>
        </div>
        <div class="info" v-if="detail.movement_type_text">
          <div class="tit">机芯类型</div>
          <div class="text">{{ detail.movement_type_text }}</div>
        </div>
        <div class="info" v-if="detail.fineness_text">
          <div class="tit">成色</div>
          <div class="text">{{ detail.fineness_text }}</div>
        </div>
        <div class="info" v-if="attachmentDisplay(detail)">
          <div class="tit">附件</div>
          <div class="text">{{ attachmentDisplay(detail) }}</div>
        </div>
        <div class="info" v-if="detail.size_desc">
          <div class="tit">尺寸/型号</div>
          <div class="text">{{ detail.size_desc }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 奢侈品箱包：asset_type = 3 -->
      <template v-if="detail.asset_type === 3">
        <div class="info">
          <div class="tit">品牌</div>
          <div class="text">{{ detail.brand_text || detail.brand }}</div>
        </div>
        <div class="info" v-if="detail.fineness_text">
          <div class="tit">成色</div>
          <div class="text">{{ detail.fineness_text }}</div>
        </div>
        <div class="info" v-if="attachmentDisplay(detail)">
          <div class="tit">附件</div>
          <div class="text">{{ attachmentDisplay(detail) }}</div>
        </div>
        <div class="info" v-if="detail.main_material_text">
          <div class="tit">主体材质</div>
          <div class="text">{{ detail.main_material_text }}</div>
        </div>
        <div class="info" v-if="detail.size_desc">
          <div class="tit">尺寸/型号</div>
          <div class="text">{{ detail.size_desc }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 钻石：asset_type = 4 -->
      <template v-if="detail.asset_type === 4">
        <div class="info" v-if="detail.brand_text || detail.brand">
          <div class="tit">品牌</div>
          <div class="text">{{ detail.brand_text || detail.brand }}</div>
        </div>
        <div class="info" v-if="detail.diamond_shape_text">
          <div class="tit">形状</div>
          <div class="text">{{ detail.diamond_shape_text }}</div>
        </div>
        <div class="info" v-if="detail.carat_range_text">
          <div class="tit">克拉区间</div>
          <div class="text">{{ detail.carat_range_text }}</div>
        </div>
        <div class="info" v-if="detail.carat_weight">
          <div class="tit">克拉重量(ct)</div>
          <div class="text">{{ detail.carat_weight }}</div>
        </div>
        <div class="info" v-if="detail.color_text">
          <div class="tit">颜色</div>
          <div class="text">{{ detail.color_text }}</div>
        </div>
        <div class="info" v-if="detail.clarity_text">
          <div class="tit">净度</div>
          <div class="text">{{ detail.clarity_text }}</div>
        </div>
        <div class="info" v-if="detail.cut_text">
          <div class="tit">切工</div>
          <div class="text">{{ detail.cut_text }}</div>
        </div>
        <div class="info" v-if="detail.fineness_text">
          <div class="tit">成色</div>
          <div class="text">{{ detail.fineness_text }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 贵金属：asset_type = 5 -->
      <template v-if="detail.asset_type === 5">
        <div class="info" v-if="detail.metal_type_text">
          <div class="tit">金属种类</div>
          <div class="text">{{ detail.metal_type_text }}</div>
        </div>
        <div class="info" v-if="detail.weight">
          <div class="tit">克重(g)</div>
          <div class="text">{{ detail.weight }}</div>
        </div>
        <div class="info" v-if="detail.metal_purity_text">
          <div class="tit">金属纯度</div>
          <div class="text">{{ detail.metal_purity_text }}</div>
        </div>
        <div class="info" v-if="detail.fineness_text">
          <div class="tit">成色</div>
          <div class="text">{{ detail.fineness_text }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 翡翠宝石：asset_type = 6 -->
      <template v-if="detail.asset_type === 6">
        <div class="info" v-if="detail.jade_color_text">
          <div class="tit">翡翠颜色</div>
          <div class="text">{{ detail.jade_color_text }}</div>
        </div>
        <div class="info" v-if="detail.jade_type_text">
          <div class="tit">种水地</div>
          <div class="text">{{ detail.jade_type_text }}</div>
        </div>
        <div class="info" v-if="detail.size_desc">
          <div class="tit">尺寸/规格</div>
          <div class="text">{{ detail.size_desc }}</div>
        </div>
        <div class="info" v-if="detail.purchase_price">
          <div class="tit">购买价格(人民币)</div>
          <div class="text">{{ detail.purchase_price }}</div>
        </div>
        <div class="info" v-if="detail.purchase_time">
          <div class="tit">购买时间</div>
          <div class="text">{{ detail.purchase_time }}</div>
        </div>
        <div class="info">
          <div class="tit">备注</div>
          <div class="text">{{ detail.remark }}</div>
        </div>
      </template>

      <!-- 照片/文件展示：图片仅展示，文档显示预览(PDF)+下载 -->
      <div class="info" v-if="detail.front && detail.front.file_path">
        <div class="tit">正面照</div>
        <div class="text">
          <el-image v-if="isImage(detail.front.file_path)" :src="detail.front.file_path" fit="fill" :preview-src-list="[detail.front.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.front.file_name || detail.front.real_name || '正面照' }}</span>
            <a v-if="isPdf(detail.front)" :href="detail.front.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.front.file_path" :download="detail.front.file_name || detail.front.real_name || '正面照'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.back && detail.back.file_path">
        <div class="tit">反面照</div>
        <div class="text">
          <el-image v-if="isImage(detail.back.file_path)" :src="detail.back.file_path" fit="fill" :preview-src-list="[detail.back.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.back.file_name || detail.back.real_name || '反面照' }}</span>
            <a v-if="isPdf(detail.back)" :href="detail.back.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.back.file_path" :download="detail.back.file_name || detail.back.real_name || '反面照'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.left && detail.left.file_path">
        <div class="tit">左侧45°</div>
        <div class="text">
          <el-image v-if="isImage(detail.left.file_path)" :src="detail.left.file_path" fit="fill" :preview-src-list="[detail.left.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.left.file_name || detail.left.real_name || '左侧' }}</span>
            <a v-if="isPdf(detail.left)" :href="detail.left.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.left.file_path" :download="detail.left.file_name || detail.left.real_name || '左侧'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.right && detail.right.file_path">
        <div class="tit">右侧45°</div>
        <div class="text">
          <el-image v-if="isImage(detail.right.file_path)" :src="detail.right.file_path" fit="fill" :preview-src-list="[detail.right.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.right.file_name || detail.right.real_name || '右侧' }}</span>
            <a v-if="isPdf(detail.right)" :href="detail.right.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.right.file_path" :download="detail.right.file_name || detail.right.real_name || '右侧'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.abrasion && detail.abrasion.file_path">
        <div class="tit">磨损痕迹</div>
        <div class="text">
          <el-image v-if="isImage(detail.abrasion.file_path)" :src="detail.abrasion.file_path" fit="fill" :preview-src-list="[detail.abrasion.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.abrasion.file_name || detail.abrasion.real_name || '磨损痕迹' }}</span>
            <a v-if="isPdf(detail.abrasion)" :href="detail.abrasion.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.abrasion.file_path" :download="detail.abrasion.file_name || detail.abrasion.real_name || '磨损痕迹'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.attachmentImage && detail.attachmentImage.file_path">
        <div class="tit">附件照片</div>
        <div class="text">
          <el-image v-if="isImage(detail.attachmentImage.file_path)" :src="detail.attachmentImage.file_path" fit="fill" :preview-src-list="[detail.attachmentImage.file_path]"></el-image>
          <span v-else class="doc-file-wrap">
            <span class="doc-name">{{ detail.attachmentImage.file_name || detail.attachmentImage.real_name || '附件' }}</span>
            <a v-if="isPdf(detail.attachmentImage)" :href="detail.attachmentImage.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.attachmentImage.file_path" :download="detail.attachmentImage.file_name || detail.attachmentImage.real_name || '附件'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>

      <div class="info" v-if="detail.extra && detail.extra.length">
        <div class="tit">补充图片</div>
        <div class="text textImg">
          <div v-for="(item,index) in detail.extra" v-if="item && item.file_path" :key="index" class="extra-item">
            <el-image v-if="isImage(item.file_path)" :src="item.file_path" fit="fill" :preview-src-list="detail.extra.map(i=>i.file_path)"></el-image>
            <span v-if="!isImage(item.file_path)" class="doc-file-wrap">
              <span class="doc-name">{{ item.file_name || item.real_name || '补充' }}</span>
              <a v-if="isPdf(item)" :href="item.file_path" target="_blank" class="doc-btn">预览</a>
              <a :href="item.file_path" :download="item.file_name || item.real_name || '补充'" target="_blank" class="doc-btn">下载</a>
            </span>
          </div>
        </div>
      </div>

      <!-- 鉴定完毕(status===1)时展示鉴定结果：结果图片仅展示，鉴定文件(PDF)提供预览+下载 -->
      <div class="info" v-if="detail.status === 1 && detail.resultImage && detail.resultImage.file_path">
        <div class="tit">鉴定结果图片</div>
        <div class="text">
          <el-image :src="detail.resultImage.file_path" fit="fill" :preview-src-list="[detail.resultImage.file_path]"></el-image>
        </div>
      </div>
      <div class="info" v-if="detail.status === 1 && detail.resultDoc && detail.resultDoc.file_path">
        <div class="tit">鉴定结果文件</div>
        <div class="text">
          <span class="doc-file-wrap">
            <span class="doc-name">{{ detail.resultDoc.real_name || detail.resultDoc.file_name || '鉴定结果' }}</span>
            <a :href="detail.resultDoc.file_path" target="_blank" class="doc-btn">预览</a>
            <a :href="detail.resultDoc.file_path" :download="detail.resultDoc.real_name || detail.resultDoc.file_name || '鉴定结果'" target="_blank" class="doc-btn">下载</a>
          </span>
        </div>
      </div>
      <div class="info" v-if="detail.status === 1 && detail.result_desc">
        <div class="tit">结果说明</div>
        <div class="text">{{ detail.result_desc }}</div>
      </div>

      <div class="info" v-if="type=='result'">
        <div class="tit">结果图片</div>
        <div class="text">
          <el-button type="primary" @click="openUpload('image')" size="small">选择图片</el-button>
          <div v-if="formData.resultImage.file_id" class="img">
            <img :src="formData.resultImage.file_path" width="100" height="100" />
          </div>
        </div>
      </div>
      <div class="info" v-if="type=='result'">
        <div class="tit">结果PDF</div>
        <div class="text">
          <el-button type="primary" @click="openUpload('pdf')" size="small">上传PDF</el-button>
          <div v-if="formData.resultPdf.file_id" class="img">
            <span>{{ formData.resultPdf.file_name || '已选择PDF文件' }}</span>
          </div>
        </div>
      </div>
      <div class="info" v-if="type=='result'">
        <div class="tit">结果说明</div>
        <div class="text">
          <el-input
            type="textarea"
            :rows="3"
            v-model="formData.result_desc"
            placeholder="请输入鉴定结论、成色等级、估值区间等说明"
          />
        </div>
      </div>

    </div>

    <div slot="footer" class="dialog-footer" v-if="type=='result'">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
    </div>

    <div slot="footer" class="dialog-footer" v-else>
      <el-button type="primary" @click="visible = false">确定</el-button>
    </div>

  </el-dialog>

  <Upload v-if="isupload" :isupload="isupload" :config="uploadConfig" @returnImgs="uploadChange">上传文件</Upload>

</div>
</template>

<script>
import AppraisalApi from '@/api/appraisal'
import Upload from '@/components/file/Upload';
export default {
  components:{Upload},
  data(){
    return{
      loading:false,
      visible:false,
      isupload:false,
      detail:null,
      type:'',
      uploadMode:'image',
      uploadConfig:{
        total:1,
        file_type:'image'
      },
      formData:{
        appraisal_id:'',
        resultImage:{},
        resultPdf:{},
        result_desc:''
      }
    }
  },
  methods:{

    /** 附件展示：使用 accessory_list（由 accessory_codes 映射的中文标签数组） */
    attachmentDisplay(row) {
      if (!row || !row.accessory_list || !row.accessory_list.length) return ''
      return row.accessory_list.join('、')
    },
    isImage(path) {
      if (!path) return false
      const lower = String(path).toLowerCase()
      return /\.(jpe?g|png|gif|webp|bmp)$/.test(lower)
    },
    isPdf(item) {
      if (!item) return false
      const p = (item.file_path || item.file_name || item.real_name || '').toLowerCase()
      return p.indexOf('.pdf') !== -1
    },

    /*提交保存*/
    submitSave(){
      let params = JSON.parse(JSON.stringify(this.formData));
      if(params.resultImage.file_id==''||!params.resultImage.file_path){
        this.$message({
          message: '请上传鉴定结果图片',
          type: 'error'
        });
        return
      }
      this.loading = true;
      AppraisalApi.appraisalAddResultImage(params).then(data => {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.visible=false
        this.$emit('refresh')
      }).finally(() => {
        this.loading = false;
      });
    },

    /*显示弹窗*/
    show(e,type){
      this.visible = true
      this.detail = e
      this.type = type
      // 每次打开根据类型重置表单，避免上一次填写残留
      if (type === 'result') {
        this.formData = {
          appraisal_id: e.appraisal_id,
          resultImage: {},
          resultPdf: {},
          result_desc: ''
        }
      } else {
        this.formData.appraisal_id = e.appraisal_id
      }
    },

    /*打开上传：mode=image/pdf*/
    openUpload(mode){
      this.uploadMode = mode
      // 根据 mode 切换上传组件配置：图片走 image，PDF 走 document
      this.uploadConfig = {
        total: 1,
        file_type: mode === 'pdf' ? 'document' : 'image'
      }
      this.isupload = true
    },

    /*上传文件返回*/
    uploadChange(e){
      if(e && e.length){
        if(this.uploadMode === 'pdf'){
          this.formData.resultPdf = e[0]
        }else{
          this.formData.resultImage = e[0]
        }
      }
      this.isupload=false
    },


  },

}
</script>

<style lang="scss" scoped>
.info{display: flex;font-size: 14px;
  .tit{width: 100px;}
  .text{flex: 1;}
}
.info+.info{padding-top: 10px;}
.el-image{background: #f5f5f5;width: 80px;height: 80px;}
.textImg{margin: -5px 0 0 -5px;
  .el-image{margin: 5px 0 0 5px;}
}
.text .doc-btn{font-size: 12px;color: #409EFF;text-decoration: none;margin-left: 8px;display: inline-block;margin-top: 4px;}
.text .doc-btn:hover{text-decoration: underline;}
.doc-file-wrap{display: inline-flex;align-items: center;flex-wrap: wrap;gap: 6px;}
.doc-file-wrap .doc-name{margin-right: 4px;max-width: 160px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.textImg .extra-item{display: inline-block;vertical-align: top;margin: 5px 0 0 5px;}
.textImg .extra-item .doc-btn{margin-left: 0;}
.img{padding-top: 10px;}
.userInfo{display: flex;
  img{width: 40px;height: 40px;}
  .main{flex: 1;padding-left: 10px;
    .name{font-size: 14px;font-weight: bold;}
    .text{color:#999;}
  }
}
</style>



// WEBPACK FOOTER //
// src/views/appraisal/appraisal/detail.vue